import { Leaf } from "lucide-react";
import ContentEditor from "@/components/ContentEditor";

export default function AdminAbout() {
  return (
    <ContentEditor
      contentKey="about"
      pageHeading="Hakkımızda sayfasını düzenle"
      description="Başlık ve gövde metnini istediğin zaman güncelleyebilirsin."
      icon={Leaf}
      redirectPath="/hakkimizda"
      successMessage="Hakkımızda sayfası güncellendi"
    />
  );
}
